import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
const SEQUENCE = ['ArrowUp', 'ArrowUp', 'ArrowDown', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'ArrowLeft', 'ArrowRight', 'b', 'a'];
const GLITCH_MS = 300;
export function KonamiGate() {
  const navigate = useNavigate();
  const idx = useRef(0);
  const [glitch, setGlitch] = useState(false);
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      const t = e.target as HTMLElement | null;
      if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.tagName === 'SELECT' || t.isContentEditable)) return;
      const key = e.key.length === 1 ? e.key.toLowerCase() : e.key;
      if (key === SEQUENCE[idx.current]) {
        idx.current += 1;
      } else {
        idx.current = key === SEQUENCE[0] ? 1 : 0;
      }
      if (idx.current === SEQUENCE.length) {
        idx.current = 0;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduce) {
          navigate('/frontier-7sigma');
          return;
        }
        setGlitch(true);
        window.setTimeout(() => navigate('/frontier-7sigma'), GLITCH_MS - 40);
        window.setTimeout(() => setGlitch(false), GLITCH_MS + 40);
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [navigate]);
  if (!glitch) return null;
  return <div className="census-glitch pointer-events-none fixed inset-0 z-[100] bg-[#05070A]/90" aria-hidden="true" data-id="element-374" data-mp="153c04jrfe4ha">
      <div className="absolute inset-x-0 top-[18%] h-[6px] bg-machine" data-id="element-375" data-mp="1063euaazdkbt" />
      <div className="absolute inset-x-0 top-[22%] h-[2px] bg-[#7FE0CC]" data-id="element-376" data-mp="v5fpru6bbdk8" />
      <div className="absolute inset-x-[10%] top-[47%] h-[14px] bg-[#7FE0CC]/70" data-id="element-377" data-mp="q7misyx6qfiw" />
      <div className="absolute inset-x-0 top-[71%] h-[3px] bg-machine/80" data-id="element-378" data-mp="3fwokhworf8e6" />
      <div className="absolute inset-0 flex items-center justify-center font-mono text-sm tracking-[0.3em] text-[#7FE0CC]" data-id="element-379" data-mp="3fxzl5nmws012">DECK 7σ</div>
    </div>;
}